export default class VideoType{
    // 不订阅视频流
    static NONE = 0;
    // 订阅大流
    static BIG_STREAM = 1;
    // 订阅小流
    static SMALL_STREAM = 2;
}
